import { Crown, Zap, Star, Trophy, Medal, Flame, Rocket, Shield, Gem, Heart, Users, Target } from "lucide-react";

export const TIER_ICONS = {
  crown: Crown, zap: Zap, star: Star, trophy: Trophy, medal: Medal, flame: Flame,
  rocket: Rocket, shield: Shield, gem: Gem, heart: Heart, users: Users, target: Target,
};

export const TierIcon = ({ icon, className = "w-5 h-5 text-pb-red" }) => {
  const Icon = TIER_ICONS[icon];
  return Icon ? <Icon className={className} /> : null;
};
